import React from 'react'

export default function FinanceDept() {
  return (
    <div>FinanceDept</div>
  )
}
